import { axiosInstance } from "../../axios-Instance";
import { getLoginToken } from "../../storage";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "../../react-query/constants";

async function getAssessment() {
  const data = await axiosInstance({
    url: "/sectionA",
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });

  return data?.data?.data;
}

const createAssessment = async (formData: any) => {
  const data = await axiosInstance({
    url: "/sectionA",
    method: "POST",
    data: formData,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });
  return data;
};

const updateAssessment = async (formData: any) => {
  const data = await axiosInstance({
    url: `/sectionA/${formData["_id"]}`,
    method: "PUT",
    data: formData,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });
  return data;
};

const deleteAssessment = async (formData: any) => {
  const data = await axiosInstance({
    url: `/sectionA/${formData}`,
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });
  return data;
};

export function useSectionA() {
  const fallback: any = [];
  const { data = fallback } = useQuery({
    queryKey: [queryKeys.sectiona],
    queryFn: () => getAssessment(),
  });
  return data;
}

export function useCreateSectionA() {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, reset, isError, error } = useMutation({
    mutationFn: (formData) => createAssessment(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.sectiona]);
    },
  });
  return { mutate, isSuccess, reset, isError, error };
}

export function useUpdateSectionA() {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, reset, isError, error } = useMutation({
    mutationFn: (formData) => updateAssessment(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.sectiona]);
    },
  });
  return { mutate, isSuccess, reset, isError, error };
}

export function useDeleteSectionA() {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, reset, isError, error } = useMutation({
    mutationFn: (formData) => deleteAssessment(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.sectiona]);
    },
  });
  return { mutate, isSuccess, reset, isError, error };
}
